import React from 'react';
import PropTypes from 'prop-types';
import Select from '@atlaskit/select';
import Button from '@atlaskit/button';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import Tooltip from '@atlaskit/tooltip';
import { Row, Cell } from '@atlaskit/table-tree';
import FieldText from '@atlaskit/field-text';

import Styled from './styled';
import Helper from './helpers';
import Letters from './cell-letters';

class Rule extends React.Component {
  constructor(props) {
    super(props);
    this.console = this.props.console;
    this.data = {
      uuid: this.props.uuid,
      cell: this.props.cell,
      row: this.props.row,
      column: this.props.column,
      formula: this.props.formula,
    };
    this.state = {
      update: 1,
    };
  }

  componentWillMount() {
    this.console.log('© Rule - Prepared');
    const { rules } = this.props;

    if (!this.data.cell) {
      const rule = rules[rules.length - 2] || {};
      const index = Letters.findIndex(elem => elem === rule.cell) + 1;
      this.data.cell = Letters[index || 0];
    }

    if (!this.data.row) {
      const result = rules.filter(elem => elem.cell === this.data.cell);
      const rule = result[result.length - 1] || {};
      this.data.row = rule.row ? rule.row + 1 : 1;
    }

    this.synchronize();
  }

  shouldComponentUpdate(nextProps, nextState) {
    const prop = JSON.stringify(this.props.columns) === JSON.stringify(nextProps.columns);
    return !prop || Helper.comparison(this.state, nextState);
  }

  componentDidUpdate() {
    this.console.log('© Rule - Rendered');
    this.synchronize();
  }

  update() {
    this.setState({ update: new Date().getTime() });
  }

  synchronize() {
    this.props.synchronize(this.props.uuid, this.data);
  }

  renderCellSelect() {
    const items = Letters.map(elem => ({
      label: elem,
      value: elem,
    }));

    const props = {
      defaultValue: items.find(elem => elem.label === this.data.cell),
      options: items,
      placeholder: 'Cell',
      spacing: 'compact',
      onChange: (option) => {
        this.data.cell = option.value;
        this.synchronize();
      },
    };

    return <Select {...props} />;
  }

  renderRowInput() {
    const props = {
      compact: true,
      min: '1',
      shouldFitContainer: true,
      type: 'number',
      value: this.data.row,
      onChange: (event) => {
        this.data.row = window.parseInt(event.target.value);
        this.synchronize();
      },
    };

    return <FieldText {...props} />;
  }

  renderColumnSelect() {
    const items = this.props.columns.map(elem => ({
      label: elem,
      value: elem,
    }));

    const props = {
      value: items.find(elem => elem.value === this.data.column),
      isDisabled: this.data.formula,
      options: items,
      placeholder: 'Column',
      spacing: 'compact',
      onChange: (option) => {
        this.data.column = option.value;
        this.update();
      },
    };

    return <Select {...props} />;
  }

  renderFormulaDataInput() {
    const props = {
      compact: true,
      shouldFitContainer: true,
      value: this.data.formula,
      onChange: (event) => {
        this.data.formula = event.target.value;
        this.update();
      },
    };

    return <FieldText {...props} />;
  }

  renderRemoveButton() {
    const props = {
      iconBefore: <CrossCircleIcon size="small" label="Remove rule" />,
      onClick: () => this.props.remove(this.props.uuid),
    };

    return <Button {...props}>Remove</Button>;
  }

  render() {
    return (
      <div data-update={this.state.update}>
        <Row>
          <Cell>{this.renderCellSelect()}</Cell>
          <Cell>
            <Styled.Textbox>
              {this.renderRowInput()}
            </Styled.Textbox>
          </Cell>
          <Cell>{this.renderColumnSelect()}</Cell>
          <Cell>
            <Styled.Textbox>
              {this.renderFormulaDataInput()}
            </Styled.Textbox>
          </Cell>
          <Cell>
            <Tooltip content="Delete this row" position="left">
              {this.renderRemoveButton()}
            </Tooltip>
          </Cell>
        </Row>
      </div>
    );
  }
}

Rule.propTypes = {
  cell: PropTypes.string,
  column: PropTypes.string,
  console: PropTypes.shape().isRequired,
  formula: PropTypes.string,
  remove: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  rules: PropTypes.arrayOf(PropTypes.object).isRequired,
  row: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  synchronize: PropTypes.func.isRequired,
  uuid: PropTypes.string.isRequired,
};

Rule.defaultProps = {
  cell: '',
  column: '',
  formula: '',
  row: 0,
};

export default Rule;
